import React, {
  forwardRef, useEffect, useMemo, useState,
} from 'react';

import { useParams } from 'react-router-dom';

import Badge from 'react-bootstrap/Badge';

import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import AsyncSelect from 'react-select';
import useUserContext from '../../hooks/useUserContext';
import {
  isAdmin,
  isCommandManagmentOrProjOffice,
  isStrategyTeam,
} from '../../services/rolesSvc';
import Required from '../Required';
import useToast from '../../hooks/useToast';
import useAPI from '../../hooks/useAPI';

import StatusBadge from '../common/StatusBadge';
import { getActionsModel } from '../../services/roles/factdataRoleStatus';
import HintCardText from "./HintCardText";
import moment from 'moment';
import Image from 'react-bootstrap/Image';
import exclamationIcon from '../../../img/icons/icon_exclamation.svg';
import {IntegerInput} from "../common/MonetaryFloatInput";
import {getMembersType} from "../../utils/members";
import {floatRenderer} from "../../services/formatSvc";
import {status as PS} from "../../helpers/passport";
import { formatDate } from '../../helpers/table';
import DateControl from '../UI/DateControl';

const roles = {
  head: 'Руководитель проекта',
  admin: 'Администратор проекта',
  participantAdmin: 'Участник с правами администратора',
  participant: 'Участник',
};

export default function EditMember({ closeCard, id }) {
  const api = useAPI();
  const addToast = useToast();
  const userCtx = useUserContext();
  const { projId, stratId, policyId, portfolioId } = useParams();

  const [project, setProject] = useState({});
  const [infoMember, setInfoMember] = useState({});
  const can = useMemo(() => getActionsModel(infoMember.status, userCtx, stratId, portfolioId, projId ?? infoMember.projId, policyId ?? infoMember.proj?.policyId, project?.status), [infoMember, userCtx,project]);

  useEffect(async () => {
    if (!id) return;
    let result = await api.get(`/factdata/teammembers/${id}`);
    result = result.teamMember;
    const result2 = await api.get(`/factdata/teamMemberInfo?sam=${result.sAMAccountName}&projId=${result.proj.id}`);
    result.role = result2.role;
    result.inclusionDate = result.inclusionDate?.split('T')[0];
    result.exclusionDate = result.exclusionDate?.split('T')[0];
    result.employmentDate = result.employmentDate?.split('T')[0];
    result.dismissalDate = result?.dismissalDate?.split('T')[0];
    result.share = result.share*100;
    const resProj = await api.get(`/projs/${result.proj.id}?readonly=true`);
    result.projs=result2.projs.filter((e)=>e.fullNumber!==resProj.fullNumber);
    setInfoMember(result);
    const user = resProj?.users?.filter((e) => e.role == 'head')[0].user;
    resProj.headName = `${user.lastName} ${user.firstName} ${user.middleName}`;
    setProject(resProj);
  }, []);

  function handleInfoMember(key, value) {
    if (value == '') value = null;
    if (key == 'isYoung') {
      value = value || false;
    }
    const obj = { ...infoMember };
    obj[key] = value;
    setInfoMember(obj);
  }

  async function saveMember() {
    // const exc=moment(infoMember.exclusionDate,"YYYY-MM-DD")
    const start=moment(project.startDate.split('T')[0],"YYYY-MM-DD")
    const end = moment(project.endDate.split('T')[0],"YYYY-MM-DD")
    const inc=moment(infoMember.inclusionDate,"YYYY-MM-DD")
    if(inc.isBefore(start) || inc.isAfter(end)){
      addToast.error("Дата включения участника не соответствует срокам проекта");
      return;
    }
    if (!infoMember?.firstName||infoMember?.share===""||infoMember?.share===null) {
      addToast.error('Заполните обязательные поля');
      return;
    }
    if (Number(infoMember?.share) > 100) {
      addToast.error("Процент участия не может быть больше 100");
      return;
    }
    if (
      infoMember.projs.map((e, i) => e.share).reduce((prev, next) => (prev += next), 0) * 100 +
        Number(infoMember?.share) >
        100 &&
      infoMember?.share > 0
    ) {
      addToast.error(
        "Участник уже добавлен в других проектах, % участия " +
          floatRenderer(infoMember.projs.map((e, i) => e.share).reduce((prev, next) => (prev += next), 0) * 100)
      );
      return;
    }
    const obj = { ...infoMember };
    obj.id = id;
    obj.share = obj.share/100;
    if (!('isYoung' in obj)) {
      obj.isYoung = false;
    }
    const result = await api.post(`/factdata/teammembers/${id}`, obj);
    if (result.id) {
      setInfoMember((prev) => ({ ...prev, id: result.id, status: result.status }));
      addToast.success('Участник сохранен');
    } else {
      addToast.error('Ошибка');
    }
  }

  const sendMember = async () => {
    await saveMember();
    const response = await api.post(`/factdata/teammembers/${id}/send`);
    if (!response.error) {
      addToast.success('Участник отправлен на согласование');
      closeCard();
    } else addToast.error(response?.error?.message || 'Не удалось произвести операцию');
  };

  async function delMember() {
    const result = await api.del(`/factdata/teammembers/${id}`);
    if (result.id) {
      addToast.success('Участник удален');
      closeCard();
    } else {
      addToast.error('Ошибка');
    }
  }

  return (
    <>
      {' '}
      <Card className="mt-4 mb-4">
        <Card.Header className="p-4" style={{ backgroundColor: cardHeaderColor }}>
          <div className="d-flex justify-content-between">
            <div>Участник команды</div>
            <div>
              <StatusBadge type="teamMember" status={infoMember?.status} />
            </div>
          </div>
        </Card.Header>

        <Card.Body className="p-4">
          <Row className="mb-4">
            <Form.Group as={Col}>
              <Form.Label style={styledLabel}>№ и название проекта</Form.Label>
              <Form.Control disabled as="textarea" value={`${project?.fullNumber} ${project?.name}`} />
            </Form.Group>
          </Row>

          <Row className="mb-4">
            <Form.Group as={Col}>
              <Form.Label style={styledLabel}>Руководитель проекта</Form.Label>
              <Form.Control disabled as="input" value={project?.headName} />
            </Form.Group>
          </Row>

          <Row className="mb-4">
            <Col md={7}>
              <Form.Group as={Col}>
                <Form.Label style={styledLabel}>
                  ФИО участника
                  {' '}
                  <Required />
                </Form.Label>
                <Form.Control
                  disabled
                  as="input"
                  value={
                    `${infoMember?.lastName
                    } ${
                      infoMember?.firstName
                    } ${
                      infoMember?.middleName
                    } (${
                      infoMember?.post
                    })`
                  }
                />
              </Form.Group>
              {infoMember.isYoung && <Form.Text style={styledHelperText} className='align-middle d-flex gap-1 mt-4'>
                <Image src={exclamationIcon}/>Входит в категорию «Сотрудник до 39 лет»
              </Form.Text>}
            </Col>

            <Col md={5}>
              <Form.Group as={Col}>
                <Form.Label style={styledLabel}>Роль</Form.Label>
                <Form.Control disabled value={roles[infoMember?.role] || ''} />
              </Form.Group>
            </Col>
          </Row>
          {infoMember?.projs?.length > 0 && <HintCardText type={getMembersType({projId,stratId,portfolioId,policyId})} projs={infoMember.projs} />}
          <Row className="mb-4">
            <Col md={4}>
              <Form.Group as={Col}>
                <Form.Label style={styledLabel}>Должность</Form.Label>
                <Form.Control disabled value={infoMember?.post || ''} />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group as={Col}>
                <Form.Label style={styledLabel}>Вид трудоустройства</Form.Label>
                <Form.Control disabled value={infoMember?.employmentType || ''} />
              </Form.Group>
            </Col>
            {/* <Col md={4}>
              <Form.Group as={Col}>
                <Form.Label style={styledLabel}>Дата приема/перевода на научную ставку</Form.Label>
                <Form.Control
                  disabled={!can.Edit||infoMember.status==="dismissed"}
                  type="date"
                  value={infoMember?.employmentDate || ''}
                  onChange={(e) => handleInfoMember('employmentDate', e.target.value)}
                />
              </Form.Group>
            </Col> */}
          </Row>

          <Row className="mb-4">
            <Form.Group as={Col}>
              <Form.Label style={styledLabel}>Категория</Form.Label>
              <Form.Control
                  disabled
                  value={infoMember?.category}
                />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label style={styledLabel}>Доля занимаемой ставки</Form.Label>
              <Form.Control disabled as="input" value={infoMember?.rate} />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label style={styledLabel}>% участия в проекте <Required/></Form.Label>
              <IntegerInput disabled={!can.Edit||infoMember.status==="dismissed"||infoMember.status==="approved"||infoMember.status=="excluded"} required value={infoMember?.share} onChange={(e) => handleInfoMember("share", e)} />
            </Form.Group>
            </Row>

          <Row className="mb-4">
            <Form.Group as={Col}>
              <Form.Label style={styledLabel}>Подразделение</Form.Label>
              <Form.Control disabled value={infoMember?.division || ''} />
            </Form.Group>
          </Row>

          <Row className="mb-4">
            <Col md={4}>
              <Form.Group as={Col}>
                <Form.Label style={styledLabel}>Дата включения в проект</Form.Label>
                <DateControl
                  disabled={!can.Edit}
                  placeholder={'дд.мм.гггг'}
                  value={infoMember.inclusionDate ? formatDate(infoMember.inclusionDate) :  null}
                  onChange={(e) => handleInfoMember('inclusionDate', `${e.getFullYear()}-${e.getMonth() + 1 < 10 ? 0 : ''}${e.getMonth() + 1}-${e.getDate() < 10 ? 0 : ''}${e.getDate()}`)}
                  minDate={new Date()}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group as={Col}>
                <Form.Label style={styledLabel}>Дата исключения из проекта</Form.Label>
                <Form.Control
                  disabled
                  type="date"
                  value={infoMember?.exclusionDate || ''}
                  onChange={(e) => handleInfoMember('exclusionDate', e.target.value)}
                />
              </Form.Group>
            </Col>

          </Row>
          <Row className="mb-4">
            <Col md={4}>
              <Form.Group as={Col}>
                <Form.Label style={styledLabel}>Дата увольнения</Form.Label>
                <Form.Control
                  disabled
                  type="date"
                  value={infoMember?.dismissalDate || ''}
                />
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {can.Edit && <Card className="p-4">
        <Form.Group as={Col}>
          <Button onClick={closeCard} variant="outline-secondary">
            Отменить
          </Button>
          {' '}
          {can.Delete && (
          <Button onClick={delMember} variant="outline-danger">
            Удалить участника
          </Button>
          )}
          {' '}
          {can.Edit && (
          <Button
            disabled={!infoMember?.firstName}
            onClick={saveMember}
            variant="primary"
          >
            Сохранить
          </Button>
          )}
          {' '}
          {can.Send && (
          <Button variant="primary" onClick={sendMember}>
            Отправить на согласование
          </Button>
          )}
          {' '}
        </Form.Group>
      </Card>}
    </>
  );
}

const styledHeading = { marginBottom: 24, textAlign: 'left' };
const cardHeaderColor = '#F7F7F7';
const styledLabel = { color: '#7F7F7F', fontWeight: '600' };
const styledHelperText = {color: '#664D03', fontSize: '16px', fontStyle: 'italic'}
